<template>
    <div id="SubidorIncidencias_div" class="w-100 px-0 py-0">
        <div style="display: flex">
            <div class="col-3 padding">
                <div class="area" v-if="subir==true">
                    <div class="row">
                        <div class="form-group col-12" >
                            <label>Seleccione el archivo PDF a subir</label>
                            <input type="file" id="archivoaSubir" v-on:change="cargarArchivo($event)" class="form-control" accept=".pdf,.doc,.docx" style="width: 100%"/>
                        </div>
                    </div>
                    <div class="row">
                        <button class="btn btn-secondary"  @click='Volver()'>Regresar</button>
                        <button class="btn btn-dark"  @click='Subir()' v-if="archivo!=null">Subir Archivo</button>
                    </div>
                </div>
                <div class="area" v-else>
                    <div class="row">
                        <button class="btn btn-secondary"  @click='Volver()'>Regresar</button>
                    </div>
                </div>
            </div>
            <div class="col-9 padding">
                <div class="area">
                    <h5>Documento</h5>
                <hr />
                <div>
                    <div id="visor_contenedor" v-if="archivo!=null">                        
                        <div id="visor_archivo">                                                 
                          <PDFDocument  :height="'750px'" :ArchivoAConvertir= "archivo" :key= "this.parametros_visorExternoPdf.key" />
                        </div>
                    </div>                      
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import router from '@/router/index'
import axios from 'axios'

export default {
    props:{
        incidencia : {
            type: Object,
            default: null},
        subir: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        PDFDocument
    },
    data(){
    return {
        enumeraciones,
        datosIncidencia : {},
        archivo: null,
        urlDocumento: '',
        parametros_visorExternoPdf: {
            key: ''
            },
        parametros: {
                extensionDocumento: ['pdf'],
            },
        }
    },
    methods: {
        cargarArchivo:function(evento){

            if(this.datosIncidencia.Digitalizado!=null ||this.datosIncidencia.Digitalizado!=false)
            {
                if(this.verificaQueSeaElDocumentoCorrecto(evento)) {                              
                //Almacenamos el archivo        
                this.archivo = evento.target.files[0];   
                const nombreCortado = evento.target.files[0].name.split(".");
                this.urlDocumento = '';                  
                this.parametros_visorExternoPdf.key = "archivoSIAP_subidor" + nombreCortado[0];
                
                } 
            }            
        },
        verificaQueSeaElDocumentoCorrecto: function(evento) {
        let siEsUnDocumentoValido = false;      
        //Se verifica que haya documento
        if(evento.target.files.length <= 0) {          
          $("#archivoaSubir").val('');
          this.archivo = null;     
          this.mensajeVisor = 'No hay ruta de archivo. Favor de volver a intentar.' 
          return siEsUnDocumentoValido;    
        }

        const nombreCortado = evento.target.files[0].name.split(".");        
        if (this.parametros.extensionDocumento.find(element => element.toLowerCase() == nombreCortado[nombreCortado.length - 1].toLowerCase()) != null)
          siEsUnDocumentoValido = true;
        else{
          let extensiones = "";
          this.parametros.extensionDocumento.forEach((element, index) => {
            extensiones += " ." + element;
            if(index < this.parametros.extensionDocumento.length - 1)
              extensiones += ",";
          });
          comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo valido. El archivo debe ser " + extensiones + ".<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
          $("#archivoaSubir").val('');
          this.archivo = null; 
          
          return siEsUnDocumentoValido;
        }
        
        return siEsUnDocumentoValido;
        },
        Volver()
        {
            router.push({name: "IncidenciasGestion", params: {NominaProps: this.datosIncidencia.PersonaIncidencia.NumeroNomina, Actualizar: true}});
        },
        Subir: function(){
            // var sobreescribir = false;
            // if(this.incidencia.Digitalizado==true)
            // {
                
            // }
            
            if(this.archivo!=null)
            {
            comun.SeEstaCargandoInformacion(true); 
            var datosDelFormulario = new FormData();
            datosDelFormulario.append("Archivo", this.archivo);
            datosDelFormulario.append("IncidenciaId", this.datosIncidencia.IncidenciaId);  
            axios.post(api.conexion + api.SIAP.funcion.GuardarDocumentoIncidencia, datosDelFormulario,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
            ).then(respuesta => { 
                if(respuesta.data.SiHayError){
                console.log(respuesta);
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                } else { 
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);  
                    this.archivo = null;
                    this.Volver()  ;
                }
                comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);                
            });    
            }
        }
    },
    mounted(){
        this.datosIncidencia = this.incidencia;
    }

}
</script>


// WEBPACK FOOTER //
// src/components/SIAP/Incidencias/SubidorDigitalIncidencia.vue